import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// 🔹 Category images
import cat1 from "../../Assets/5th_slider/pngegg (3) 1.png";
import cat2 from "../../Assets/5th_slider/pngegg (3) 1 (1).png";
import cat3 from "../../Assets/5th_slider/pngegg (3) 1 (2).png";
import cat4 from "../../Assets/5th_slider/pngegg (3) 1 (3).png";
import cat5 from "../../Assets/5th_slider/pngegg (3) 1 (4).png";
import cat6 from "../../Assets/5th_slider/pngegg (3) 1 (5).png";
import Six_slider from "./Six_slider";

const categories = [
    { img: cat1, title: "Must Haves" },
    { img: cat2, title: "Sport Nutrition" },
    { img: cat3, title: "Vitamins & Supplements" },
    { img: cat4, title: "Skin Care" },
    { img: cat5, title: "Diabetes Essentials" },
    { img: cat6, title: "Heart Care" },
];

const Fifth_slider = () => {
    return (
        <>
        <div className="w-full bg-white py-10">
            <div className="max-w-7xl mx-auto px-4">

                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-[26px] font-medium text-black">
                        Shop by Categories
                    </h2>

                    {/* Arrows (UI only) */}
                    <div className="flex gap-3">
                        <button className="w-10 h-10 rounded-full bg-teal-700 flex items-center justify-center text-white">
                            <ChevronLeft size={18} />
                        </button>
                        <button className="w-10 h-10 rounded-full bg-teal-700 flex items-center justify-center text-white">
                            <ChevronRight size={18} />
                        </button>
                    </div>
                </div>

                {/* Categories */}
                <div
                    className="
            grid
            grid-cols-2
            sm:grid-cols-3
            md:grid-cols-4
            lg:grid-cols-6
            gap-6
          "
                >
                    {categories.map((cat, index) => (
                        <div
                            key={index}
                            className="
                flex
                flex-col
                items-center
                text-center
                cursor-pointer
              "
                        >
                            {/* Image Card */}
                            <div
                                className="
    relative
    w-[175px]
    h-[175px]
    rounded-[12.59px]
    bg-[#F8F8F8]
    flex
    items-center
    justify-center
    opacity-100
  "
                            >


                                <img
                                    src={cat.img}
                                    alt={cat.title}
                                    className="
    absolute
    top-[25px]
    left-[25px]
    w-[125px]
    h-[125px]
    object-contain
    opacity-100
  "
                                />

                            </div>

                            {/* Title */}
                            <p
                                className="
    mt-3
    font-inter
    font-normal
    text-[17px]
    leading-[100%]
    tracking-normal
    text-center
    text-[#060A0B]
  "
  
                            >
                                {cat.title}
                            </p>

                        </div>
                    ))}
                </div>

            </div>
        </div>
                {/* <Six_slider/> */}
        </>
    );
};

export default Fifth_slider;
